import { CONVERSATION_STATUS, SERVICE_TICKET_STATUS, SERVICE_TICKET_SUMMIT_STATUS } from '@/constant'
import xss, * as xssTool from 'xss'
import dayjs from 'dayjs'

export * from './browser'

/**
 * 能否删除会话
 */
export function canDeleteConversation(service) {
  if (!service) return false
  // 是否结束会话了
  const isEndIm = service.status !== CONVERSATION_STATUS.ON_GOING
  // 是否完成小结单了
  const isFinishRecord = service.serviceTicketStatus > SERVICE_TICKET_STATUS.notCreate
  // 是否没有回访了
  const notFollowUpPlan = !service.followUpPlanTime
  // 是否禁止提交小结单了
  const disableSubmitRecord = [
    SERVICE_TICKET_SUMMIT_STATUS.DisableSubmitA,
    SERVICE_TICKET_SUMMIT_STATUS.DisableSubmitB
  ].includes(service.toSubmitRecordStatus)
  if (isEndIm && (isFinishRecord || disableSubmitRecord) && notFollowUpPlan) {
    return true
  }
  return false
}

// 清除浏览器头像缓存
export function clearAvatarCache(base64Avatar) {
  try {
    if (base64Avatar) {
      window.URL.revokeObjectURL(base64Avatar)
      console.log('已清除浏览器头像缓存')
    }
  } catch (e) {
    console.info(e)
  }
}

/**
 * 获取html中的纯文本
 * @param html
 * @param isTrim
 * @returns {string}
 */
export function getHtmlText(html, isTrim = false) {
  let temp = document.createElement('div')
  temp.innerHTML = html
  const output = temp.innerText || temp.textContent
  temp = null
  if (isTrim) return output?.trim?.() || output
  return output
}

/**
 * 清洗输入文字
 * @param content
 * @returns {string}
 */
export function pasteTextHandle(content) {
  // let html = content.replace(/\/'|\/"/g, '&quot;') // 为了解决内容带有引号导致的不能粘贴问题
  console.log(
    '粘贴内容(JSON化)：',
    JSON.stringify(content),
    '\n粘贴转换后(JSON化)：',
    JSON.stringify(getHtmlText(content))
  )
  // 处理HTML内容：将<br>, <p>等标签转换为换行符，然后统一处理
  let html = content || ''
  // 将<br>标签替换为换行符
  html = html.replace(/<br\s*\/?>/gi, '\n')
  // 将</p>标签替换为换行符
  // html = html.replace(/<\/p>/gi, '\n')
  // 获取纯文本
  const result = getHtmlText(html)
  // 移除末尾换行符和前后空格，然后将换行符转回<br>
  return (
    _.trim(result || '')
      .replace(/\n/g, '<br>')
      // 移除末尾换行符
      .replace(/((<br\s*\/?>)|(\n))+$/i, '')
  )
}

/**
 * 获取聊天消息结构
 * @param fromUid
 * @param toUid
 * @param baseContent
 * @param type
 * @param extend
 * @param needParser
 * @param expand
 * @returns {{cometUserId, ext: {needParser, npcAccountId, customerServiceNumber, userid, username}, inSeqId: string, outSeqId: string, toUid, c_pushStatus: number, fromUid, workbenchId, base: {conversationType: number, valid: number, replySeqID: number, readTime: number, customerSource: string, type, msgStatus: number, content, chatType: string, timestamp: number}}}
 */
export function createMessage(fromUid, toUid, baseContent, type, extend, needParser, expand = {}) {
  return {
    fromUid, // 客服uid
    toUid, // 客户uid
    inSeqId: '',
    outSeqId: '',
    c_pushStatus: 1, // 前端自己添加的字段 用来标记消息发送状态 不会上传到服务器  0：发送失败 1: 发送中  2：发送成功
    base: {
      chatType: 'chat', // 聊天类型 chat：单聊；groupchat：群聊；
      conversationType: 4, // 会话类型 1： 普通； 2： 聊天助手；3：论坛小秘书；4：在线客服
      customerSource: 'From', // 有From和To两个值 如果FromUid是客服填写From，如果ToUid是客服填写To
      msgStatus: 0, // 消息状态 0：未读，1：已读
      readTime: 0, // 消息被读时间
      replySeqID: 0,
      valid: 1, // 是否有效 0 无效 1 有效 2 已删除 3 已撤回
      timestamp: Date.now(), // 消息发送时间
      sendTime: '',
      content: baseContent,
      type
    },
    cometUserId: toUid,
    workbenchId: extend.id,
    ext: {
      // 扩展字段
      npcAccountId: extend.accountId,
      userid: extend.accountId,
      username: extend.accountName,
      serviceAvatar: extend.serviceAvatar,
      // workbenchId: workingObj.id,
      customerServiceNumber: fromUid,
      needParser,
      workbenchServiceSend: 1 // 工作台客服发送
    },
    ...expand
  }
}

/**
 * 根据会话状态、评价时间创建结束、评价cmd消息
 */
export function createCmdMsg({
  fromUid,
  toUid,
  endConversationTime,
  evaluateTime,
  status,
  workingObj,
  needParser = 0
}) {
  // 监听变化 用来初始化是添加cmd消息
  const content = []
  // 会话结束cmd  3正常结束  5超时结束
  // _endInList _evalInList 用来判断定cmd消息是否在会话列表中
  const textMap = {
    3: '会话已结束',
    5: '超时自动结束',
    7: '转接成功，该会话已结束'
  }
  if (textMap[status]) {
    const text = textMap[status]
    const _content = createMessage(
      fromUid,
      toUid,
      { action: 'close', _endInList: true, content: { text } },
      'cmd',
      workingObj,
      needParser
    )
    _content.base.timestamp = endConversationTime
    content.push(_content)
  }
  // 用户已评价cmd
  if (evaluateTime) {
    const _content = createMessage(
      fromUid,
      toUid,
      { action: 'invite_comment', _evalInList: true, content: { text: '用户已评价' } },
      'cmd',
      workingObj,
      needParser
    )
    _content.base.timestamp = evaluateTime
    content.push(_content)
  }
  return content
}

/**
 * 过滤已经存在的cmd消息： 离线，评价， 会话结束
 *
 * @param {Object} content 消息内容
 * @param {Array} list 已有的列表内容
 */
export function filterExistCmdMsg(content, list) {
  let _content = Array.isArray(content) ? content : [content]
  const outSeqIds = list.map(v => v.outSeqId)
  // 这个地方去重不能把outSeqId为空的去重掉，因为默认发送消息就是空，等待服务端返回outSeqId才有值
  _content = _content.filter(v => !outSeqIds.includes(v.outSeqId) || !v.outSeqId)
  list.forEach(v => {
    if (!v || v.base?.type !== 'cmd') return
    if (v.base.content._endInList) {
      const index = _content.findIndex(msg => msg.base.content._endInList)
      if (index > -1) {
        _content.splice(index, 1)
      }
    }
    if (v.base.content._evalInList) {
      const index = _content.findIndex(msg => msg.base.content._evalInList)
      if (index > -1) {
        _content.splice(index, 1)
      }
    }
  })
  return _content
}

/**
 * 是不需要需要展示的cmd消息？
 * @param cmdMsg
 * @returns {boolean}
 */
export function isNoShowCmdMsg(cmdMsg) {
  return cmdMsg.base.type === 'cmd' && ['read_message', 'endConversation'].includes(cmdMsg.base.content.action)
  // // 如果不是cmd肯定直接返回false
  // if (cmdMsg.base.type !== 'cmd') return false
  // // 如果是cmd，无text不展示
  // if (cmdMsg.base.content?.content?.text) return false
  // return true
}

/**
 * 根据对象中的key 生成以key为属性的map
 *
 * @param {Array} arr 要处理的数组
 * @param {String} key 对象中的属性
 * @returns {Object}
 */
export function splitArrayByKey(arr, key) {
  const res = {}
  arr.forEach(v => {
    const id = v[key]
    if (id in res) {
      res[id].push(v)
    } else {
      res[id] = [v]
    }
  })
  return res
}

/**
 * 过滤消息card -> notify 消息  此消息是在客户端提示敏感词
 */
export function filterCardNotify(list) {
  if (!Array.isArray(list)) return []
  return list.filter(msg => !(msg.base.type === 'card' && msg.base.content.type === 'notify'))
}

export function formatHtmlToInputHtml(htmlStr) {
  let temp = document.createElement('div')
  // xss https://jsxss.com/zh/index.html
  htmlStr = xss(htmlStr, {
    whiteList: {
      a: ['href', 'target', 'title'],
      br: []
    }, // 白名单为空，表示过滤所有标签
    allowCommentTag: false, // 自动去掉HTML中的备注
    stripIgnoreTag: true, // 过滤所有非白名单标签的HTML
    safeAttrValue(tag, name, value) {
      // 返回一个字符串表示该属性值, a标签的href不能处理，否则href中ymm格式的地址就没了
      // 示例：请点击下面链接修改手机号:<a href="ymm://view/changetelbyid">修改手机号</a>
      if (tag === 'a') {
        return value
      }
    }
  }).replace(/\n/g, '<br>')
  console.log(111, htmlStr)
  temp.innerHTML = `${xssTool.escapeHtml(htmlStr)}`
  const output = temp.innerText || temp.textContent
  temp = null
  return output
}
